import axios from "../libs/axios.lib";
import * as loginUtils from "../utils/login.utils";

export async function deleteCampaignAPI(campaign_id) {
	const token = loginUtils.getUser().token;

  console.log(campaign_id)
	await axios.delete("/campaigns/delete/" + encodeURIComponent(campaign_id), {
		headers: {
			Authorization: token,
		},
	});

	return true;
}

export async function updateCampaignAPI(campaignId, billboards) {
  const token = loginUtils.getUser().token;

  try {
      const response = await axios.put("/campaigns/update/" + encodeURIComponent(campaignId), 
          billboards, 
          { headers: { Authorization: token } }
      );

      return response.data;
  } catch (error) {
      console.error("Error updating campaign:", error);
      return null;
  }
}


export async function fetchBillboardsForCampaign(campaignId) {
  const token = loginUtils.getUser().token;

  try {
      const response = await axios.get(`/campaigns/fetchbillboards/${encodeURIComponent(campaignId)}`, {
          headers: { Authorization: token },
      });

      return response.data.billboards; // Returns list of billboards
  } catch (error) {
      console.error("Error fetching billboards:", error);
      return [];
  }
}


export async function createCampaignByBriefId(body = {
    briefId:null, billboards: ""}) {
    const token = loginUtils.getUser().token;

    const {data} = await axios.post("/campaigns/create-by-brief-id",
        body, {
        headers: { Authorization: token },
    });
    return data;
}

export async function createCampaignManually(body = {billboards: ""}) {
    const token = loginUtils.getUser().token;

    const {data} = await axios.post("/campaigns/create-manual",
        body, {
        headers: { Authorization: token },
    });
    return data;
}


export async function getCampaignListAPI() {
	const token = loginUtils.getUser().token;

	const { data } = await axios.get("/campaigns/campaigns", {
		headers: {
			Authorization: token,
		},
	});

	return data;
}

export async function fetchBillboardsByBrief(briefId) {
    if (!briefId) throw new Error("Brief ID is required");
    const token = loginUtils.getUser().token;
    const data  = await axios.get("campaigns/by-brief/" + encodeURIComponent(briefId), {
		headers: {
			Authorization: token,
		},
	});
    console.log(data)
    return data;
};


export async function getCampaignVisibilityData(campaignId) {
    const token = loginUtils.getUser().token;
 

  
    try {
      const response = await axios.get("campaigns/campaign-visibility-map/" + encodeURIComponent(campaignId), {
        headers: {
          Authorization: token,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching visibility data:", error);
      return [];
    }
  }

  export async function getCampaignBillboardsAPI(campaignId) {
    if (!campaignId) throw new Error("Campaign ID is required");
    const token = loginUtils.getUser().token;
  
    const { data } = await axios.get(
      "/campaigns/" + encodeURIComponent(campaignId) + "/billboards",
      {
        headers: {
          Authorization: token,
        },
      }
    );
  
    return data;
  }
  

  export async function getBoxPlotDataAPI(payload) {
    const token = loginUtils.getUser().token;
  
    try {
      const { data } = await axios.post(
        "/campaigns/campaign-boxplot-data",
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return data;

      console.log(data);
    } catch (error) {
      console.error("Error fetching box plot data:", error);
      return [];
    }
  }

  
  export async function getDayOfWeekBoxPlotDataAPI(payload) {
    const token = loginUtils.getUser().token;
  
    try {
      const { data } = await axios.post(
        "/campaigns/campaign-dayofweek-boxplot-data",
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return data;

      console.log(data);
    } catch (error) {
      console.error("Error fetching box plot data:", error);
      return [];
    }
  }
  

  export async function getlinegraphDataAPI(payload) {
    const token = loginUtils.getUser().token;
  
    try {
      const { data } = await axios.post(
        "/campaigns/campaign-linegraph-data",
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return data;

 
    } catch (error) {
      console.error("Error fetching box plot data:", error);
      return [];
    }
  }


  export async function getMonthlyHeatmapAPI(payload) {
    const token = loginUtils.getUser().token;
  
    try {
      const { data } = await axios.post(
        "/campaigns/campaign-monthly-heatmap-data",
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return data;

 
    } catch (error) {
      console.error("Error fetching box plot data:", error);
      return [];
    }
  }

  export async function getDailyLineGraphAPI(payload) {
    const token = loginUtils.getUser().token;
  
    try {
      const { data } = await axios.post(
        "/campaigns/campaign-daily-linegraph",
        payload,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return data;

 
    } catch (error) {
      console.error("Error fetching box plot data:", error);
      return [];
    }
  }


  export async function downloadCampaignPPTAPI(campaignId) {
    const token = loginUtils.getUser().token;
  
    const response = await axios.get("/campaigns/" + encodeURIComponent(campaignId) + "/downloadcampaignppt", {
      headers: {
        Authorization: token,
      },
      responseType: "blob",
    });
  
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
  
    link.setAttribute("download", "presentation.pptx");
    document.body.appendChild(link);
    link.click();
  
    window.URL.revokeObjectURL(url);
  }

export async function getImpressionLineChartAPI(payload) {
  const token = loginUtils.getUser().token;
  try {
    const response = await axios.post("/campaigns/impression-linechart", payload, {
      headers: { Authorization: token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching impression line chart data:", error);
    return [];
  }
}

export async function getImpressionScatterplotAPI(payload) {
  const token = loginUtils.getUser().token;
  try {
    const response = await axios.post("/campaigns/impression-scatterplot", payload, {
      headers: { Authorization: token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching impression scatterplot data:", error);
    return [];
  }
}

export async function getImpressionDayOfWeekAPI(payload) {
  const token = loginUtils.getUser().token;
  try {
    const response = await axios.post("/campaigns/impression-dayofweek", payload, {
      headers: { Authorization: token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching impression day of week data:", error);
    return [];
  }
}

export async function getImpressionMonthlyAPI(payload) {
  const token = loginUtils.getUser().token;
  try {
    const response = await axios.post("/campaigns/impression-monthly", payload, {
      headers: { Authorization: token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching impression monthly data:", error);
    return [];
  }
}



export async function getCampaignImpressionData(campaignId) {
    const token = loginUtils.getUser().token;
 

  
    try {
      const response = await axios.get("campaigns/campaign-impression-map/" + encodeURIComponent(campaignId), {
        headers: {
          Authorization: token,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching visibility data:", error);
      return [];
    }
  }